import { Instance } from 'mobx-state-tree';
import { CustomerProfileTimeWindowDtoModelBase } from './CustomerProfileTimeWindowDtoModel.base';
import { IStopFormTimeWindow } from '../../../components/orders/OrderForm/orderFormHelpers';

/* The TypeScript type of an instance of CustomerProfileTimeWindowDtoModel */
export interface CustomerProfileTimeWindowDtoModelType extends Instance<typeof CustomerProfileTimeWindowDtoModel.Type> {}

/* A graphql query fragment builders for CustomerProfileTimeWindowDtoModel */
export { selectFromCustomerProfileTimeWindowDto, customerProfileTimeWindowDtoModelPrimitives, CustomerProfileTimeWindowDtoModelSelector } from './CustomerProfileTimeWindowDtoModel.base';

/**
 * CustomerProfileTimeWindowDtoModel
 */
export const CustomerProfileTimeWindowDtoModel = CustomerProfileTimeWindowDtoModelBase
  .views(self => ({
    get timeWindowObject(): IStopFormTimeWindow | undefined {
      if (self.startTime === null) {
        return { startTime: undefined, endTime: self.endTime === null ? undefined : self.endTime };
      }
      if (self.endTime === null) {
        return { startTime: self.startTime === null ? undefined : self.startTime, endTime: undefined };
      }
      return (self.startTime !== undefined || self.endTime !== undefined)
        ? { startTime: self.startTime, endTime: self.endTime }
        : undefined;
    },
  }))
  .actions(self => ({
    log() {
      console.log(JSON.stringify(self));
    },
  }));
